import ProjectedRequirementsPanel from './ProjectedRequirementsPanel';

export default ProjectedRequirementsPanel;
